var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="workspace-content-overlay">\n	<div class="empty-state empty-state-lg fill-container">\n		<div class="ldi ldi-spinner ldi-spin-slow empty-state-img"></div>\n		<div class="empty-state-blurb">\n			<p>Loading...</p>\n		</div>\n	</div>\n</div>\n';
}
return __p;
};
